import { render } from "./FormLogoHeader.vue?vue&type=template&id=1f25fc28&scoped=true"
import script from "./FormLogoHeader.vue?vue&type=script&lang=js"
export * from "./FormLogoHeader.vue?vue&type=script&lang=js"

import "./FormLogoHeader.vue?vue&type=style&index=0&id=1f25fc28&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f25fc28"],['__file',"src/components/patientReport/header/dlw/FormLogoHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f25fc28"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f25fc28', __exports__)) {
    console.log('reload')
    api.reload('1f25fc28', __exports__)
  }
  
  module.hot.accept("./FormLogoHeader.vue?vue&type=template&id=1f25fc28&scoped=true", () => {
    console.log('re-render')
    api.rerender('1f25fc28', render)
  })

}


export default __exports__